import { render, staticRenderFns } from "./customerSource.vue?vue&type=template&id=0224ca7a&scoped=true&"
import script from "./customerSource.vue?vue&type=script&lang=js&"
export * from "./customerSource.vue?vue&type=script&lang=js&"
import style0 from "./customerSource.vue?vue&type=style&index=0&id=0224ca7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224ca7a",
  null
  
)

component.options.__file = "customerSource.vue"
export default component.exports